"use client";

import React from "react";
import Timesheet from "../../components/Timesheet";
import PageHeader from "../../components/ui/PageHeader";
import { Clock } from "lucide-react";

export default function TimesheetPage() {
  return (
    <div className="p-4 lg:p-6">
      <PageHeader
        title="Timesheets"
        description="View and manage employee timesheets"
        icon={Clock}
        variant="card"
        className="mb-6"
      />
      <Timesheet />
    </div>
  );
}
